export default {"src":"/_next/static/media/jollyroom-logo.031c14b7.svg","height":181,"width":796,"blurWidth":0,"blurHeight":0};